import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PersonIcon from "@mui/icons-material/Person";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SecurityIcon from "@mui/icons-material/Security";
import { useNavigate } from "react-router-dom";

const settings = [
  {
    title: "Change Password",
    description: "Update your current password for security",
    icon: <LockIcon fontSize="large" color="primary" />,
    path:"/ChangePassword"
  },
  {
    title: "Update Email",
    description: "Coming soon 🚧",
    icon: <EmailIcon fontSize="large" color="primary" />,
    path:"/UpdateMail"
  },
  {
    title: "Two-Factor Authentication",
    description: "Coming soon 🚧",
    icon: <PhoneAndroidIcon fontSize="large" color="primary" />,
    path:"/Two-Factor Authentication"
  },
  {
    title: "Profile Information",
    description: "Coming soon 🚧",
    icon: <PersonIcon fontSize="large" color="primary" />,
    path:"/Profile Information"
  },
//   {
//     title: "Privacy Settings",
//     description: "Control what information you share",
//     icon: <SecurityIcon fontSize="large" color="primary" />,
//   },
];

const MotionCard = motion(Card);

const GeneralSettings = () => {
  const theme = useTheme();
  const navigate = useNavigate()
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissionList = Object.keys(permissions);

 const canUploadDocs = (process.env.REACT_APP_FLAG_DEV || process.env.REACT_APP_FLAG_USA ||  process.env.REACT_APP_FLAG_INTERNAL||process.env.REACT_APP_FLAG_SAN_HC)  && ( permissionList?.includes("admin") || permissionList?.includes("Code Accelerate") || permissionList?.includes("Code Assist"))

    const settingsItems = [
    ...settings,
    ...(canUploadDocs
      ? [
          {
            title: "Upload Documents",
            description: "Upload your documents securely",
            icon: <CloudUploadIcon fontSize="large" color="primary" />,
            path: "/settings-upload-document",
          },
        ]
      : []),
  ];

  // Optional: Deduplicate by title (in case of weird edge cases)
  const uniqueSettings = Array.from(
    new Map(settingsItems.map((item) => [item.title, item])).values()
  );


const handleNaigatetoGeneralScreens = (path) =>{
    navigate(path)
}

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        ⚙️ General Settings
      </Typography>

      <Grid container spacing={2}>
        {uniqueSettings?.map((setting, index) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={index} sx = {{display:"flex",justifyContent:"center",width:{xl:"24%",sm:"48%",md:"30%",xs:"100%"}}}>
            <MotionCard
             onClick={()=>handleNaigatetoGeneralScreens(setting.path)}
              whileHover={{
                scale: 1.03,
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
              }}
              whileTap={{ scale: 0.98 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: index * 0.1,
                type: "spring",
                stiffness: 120,
              }}
              sx={{
                width: "100%",
                height: "100%", 
                 maxWidth: "100%",
                // height:200,
                borderRadius: 4,
                boxShadow: 2,
                p: 2,
               

                background: theme.palette.background.paper,
                transition: "all 0.3s ease-in-out",
              }}
            >
           
              <CardContent>
                <Box display="flex" alignItems="center" mb={1.5}>
                  <IconButton size="large" disabled sx={{ mr: 1 }}>
                    {setting.icon}
                  </IconButton>
                  <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    {setting.title}
                  </Typography>
                </Box>
                <Typography variant="body2" sx = {{ml:2.2}} color="text.secondary">
                  {setting.description}
                </Typography>
              </CardContent>
            </MotionCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GeneralSettings;
